import _ from 'lodash';
import abtest from './abtest'
import {isLoggedIn, isStudent} from './UserService';
import {shouldShowPricing, getSignupPricingTableName} from '../pages/new/signup/signup_helpers';
const pathname = window.location.pathname
let tmp = pathname.split('/app/pricing/')
if (pathname.includes('pricing-table')) {
  tmp = pathname.split('/app/pricing-table/')
}
let role = 'teacher'
//special hack for paid traffic
if (pathname.includes('sign-up/') && shouldShowPricing()) {
  role = getSignupPricingTableName();
} else if (tmp.length > 1) {
  role = tmp[1].toLowerCase().replaceAll('%20', '').trimEnd();
} else if (isLoggedIn()) {
  role = isStudent() ? 'student' : 'teacher';
}
export const PRICING_ROLE_NAME = role;
export const plans = _.result(abtest, `subscriptionType.plans[${role}].plans`,
  _.result(abtest, `subscriptionType.plans[${role}]`, []))
export const table_options = _.defaults(_.result(abtest, `subscriptionType.plans[${role}].table_options`, {}),
  {
    "show_title": true,
    "banner_image_url": null,
    "table_type": 'default',
    "title": "Choose the plan that’s right for you",
    "sub_title": "This feature requires a subscription to our premium plans",
    "money_back_title": "Money back guarantee",
    "money_back_text": "You can cancel at anytime within the 30-day trial period.",
    "no_cc": false
  })
